"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubTitle = exports.DelButton = exports.Thumbs = exports.ViewPort = exports.ThumbDiv = exports.ImageDiv = exports.HiddenInput = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const HomePageAll_1 = require("../../StyledComponents/HomePageAll");
exports.HiddenInput = styled_components_1.default.input `
  position: fixed;
  height: 2px;
  width: 2px;
  opacity: 0;
`;
exports.ImageDiv = styled_components_1.default.img `
  &.show {
    display: block;
  }
  &.hide {
    display: none;
  }
  cursor: pointer;
  margin: auto;
  display: block;
`;
exports.ThumbDiv = styled_components_1.default.div `
  width: 50px;
  height: 50px;
  display: inline-block;
  margin-top: 10px;
  margin-right: 5px;
  &.selected {
    box-shadow: ${({ theme }) => theme.palette.border.focus} 0px 0px 3px;
  }
  img {
    max-width: 50px;
    max-height: 50px;
    &.show {
      display: block;
    }
    &.hide {
      display: none;
    }
  }
  cursor: pointer;
`;
exports.ViewPort = styled_components_1.default.div `
  overflow: scroll;
  height: 415px;
`;
exports.Thumbs = styled_components_1.default.div `
  padding: 15px;
  padding-top: 0px;
  width: 80%;
`;
exports.DelButton = (0, styled_components_1.default)(HomePageAll_1.MyBlueButton) `
  position: absolute;
  right: 10px;
  margin-top: 10px;
`;
exports.SubTitle = styled_components_1.default.p `
  font-size: 12px;
  text-align: center;
`;
